<div class="list">
  <app-notification-item
    (action)="notificationAction($event)"
    (remove)="removeNotification($event)"
    [index]="i"
    *ngFor="let item of filteredNotificationsList; trackBy: trackByItems; let i = index"
    [notification]="item"></app-notification-item>
</div>
